exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?minimize!handsontable/dist/handsontable.full.css"), "");

// module
exports.push([module.id, ".DuzenlemeModu[data-v-7c02b3f5]{color:red;border-bottom:1px solid #ccc;margin-top:-10px;padding-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7c02b3f5","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/_Sayac/Bina/DuzenlemeTable.vue
// module id = 999
// module chunks = 0